import Vue from 'vue';
import VueI18n from 'vue-i18n';

import settings from './_i18n.settings';

Vue.use(VueI18n);

export default new VueI18n(settings);
